/**
 * Swatch PDP — in-page tab panels (no navigation on tab click).
 */
function initSwatchProductTabs() {
  document.querySelectorAll('[data-swatch-product-tabs]').forEach(function (root) {
    if (root.dataset.swatchTabsBound === '1') return;
    root.dataset.swatchTabsBound = '1';

    var tabButtons = root.querySelectorAll('[data-swatch-tab]');
    var panels = root.querySelectorAll('[data-swatch-panel]');

    if (!tabButtons.length || !panels.length) return;

    function handleListIncludes(listAttr, handle) {
      if (!listAttr || !handle) return false;
      return listAttr.split('|').indexOf(handle) !== -1;
    }

    function getLaneFromUrlParams() {
      var urlParams = new URLSearchParams(window.location.search);
      var tabReady = urlParams.get('tab-ready');
      var tabCustom = urlParams.get('tab-custom');
      var tabAccessories = urlParams.get('tab-accessories');

      if (tabReady && handleListIncludes(root.dataset.instockHandles, tabReady)) {
        return 'instock';
      }
      if (tabCustom && handleListIncludes(root.dataset.customHandles, tabCustom)) {
        return 'custom';
      }
      if (tabAccessories && handleListIncludes(root.dataset.accessoriesHandles, tabAccessories)) {
        return 'accessories';
      }
      return '';
    }

    function revealOosContextTab(tabId) {
      var tabButton = root.querySelector('[data-swatch-tab="' + tabId + '"]');
      var tabItem = tabButton ? tabButton.closest('.swatch-product-tabs__tab') : null;
      if (tabItem && tabItem.classList.contains('swatch-product-tabs__tab--oos-context')) {
        tabItem.classList.remove('hidden');
      }

      var panel = root.querySelector('[data-swatch-panel="' + tabId + '"]');
      if (panel && panel.classList.contains('swatch-product-tabs__panel--oos-context')) {
        panel.classList.remove('hidden');
      }
    }

    function activateTab(tabId) {
      revealOosContextTab(tabId);

      tabButtons.forEach(function (button) {
        var isActive = button.getAttribute('data-swatch-tab') === tabId;
        var tabItem = button.closest('.swatch-product-tabs__tab');

        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (tabItem) {
          tabItem.classList.toggle('active', isActive);
        }
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-swatch-panel') === tabId;
        panel.classList.toggle('hidden', !isActive);
      });
    }

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var tabId = button.getAttribute('data-swatch-tab');
        if (!tabId) return;
        activateTab(tabId);
      });
    });

    var urlLane = getLaneFromUrlParams();
    if (urlLane) {
      activateTab(urlLane);
      return;
    }

    var defaultTab = root.getAttribute('data-default-tab');
    if (defaultTab) {
      activateTab(defaultTab);
    }
  });
}

document.addEventListener('DOMContentLoaded', initSwatchProductTabs);
document.addEventListener('swup:page:view', initSwatchProductTabs);
